// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DemoApi from "../bindings/DemoApi.bs.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as RelayRuntime from "relay-runtime";

async function fetchQuery(operation, variables, _cacheConfig, _uploadables) {
  let body = Stdlib_Option.getOr(JSON.stringify({
    query: operation.text,
    variables: variables
  }), "{}");
  let response = await fetch(DemoApi.graphqlEndpoint(), {
    method: "POST",
    headers: {
      "content-type": "application/json",
      accept: "application/json"
    },
    body: body
  });
  return await response.json();
}

let network = RelayRuntime.Network.create(fetchQuery);

let environment = RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), undefined, undefined), undefined, undefined, undefined, undefined, undefined);

export {
  fetchQuery,
  network,
  environment,
}
/* network Not a pure module */
